"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _animator = _interopRequireDefault(require("../animator"));
var _frap = _interopRequireDefault(require("../frap"));
var _icon = _interopRequireDefault(require("../icon"));
var _chevronRight = _interopRequireDefault(require("../../icons/chevron-right"));
var _chevronLeft = _interopRequireDefault(require("../../icons/chevron-left"));
var _classnames = _interopRequireDefault(require("classnames"));
require("./carousel-pager-button.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var PagerButton = function PagerButton(_ref) {
  var active = _ref.active,
    alwaysVisible = _ref.alwaysVisible,
    ariaLabelNext = _ref.ariaLabelNext,
    ariaLabelPrev = _ref.ariaLabelPrev,
    buttonClassName = _ref.buttonClassName,
    carouselId = _ref.carouselId,
    clickHandler = _ref.clickHandler,
    directionName = _ref.directionName,
    style = _ref.style;
  var config = {
    prev: {
      ariaLabel: ariaLabelPrev !== null && ariaLabelPrev !== void 0 ? ariaLabelPrev : 'Previous',
      className: 'carouselPager--prev',
      iconPath: _chevronLeft["default"]
    },
    next: {
      ariaLabel: ariaLabelNext !== null && ariaLabelNext !== void 0 ? ariaLabelNext : 'Next',
      className: 'carouselPager--next',
      iconPath: _chevronRight["default"]
    }
  };
  var direction = config[directionName];
  var divClasses = (0, _classnames["default"])('absoluteCenter-y carouselPager py2', buttonClassName, direction.className, {
    pl2: directionName === 'next',
    pr2: directionName !== 'next'
  });
  var frapClasses = (0, _classnames["default"])('block color-black60 carouselPager__button', {
    'carouselPager__button--alwaysVisible': alwaysVisible
  });
  return /*#__PURE__*/_react["default"].createElement("div", {
    "aria-disabled": !active,
    className: divClasses,
    onClick: clickHandler,
    style: style
  }, /*#__PURE__*/_react["default"].createElement(_animator["default"], null, active && /*#__PURE__*/_react["default"].createElement(_frap["default"], {
    "aria-controls": carouselId,
    circular: true,
    className: frapClasses,
    key: direction.ariaLabel,
    mini: true
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "hiddenVisually"
  }, direction.ariaLabel), /*#__PURE__*/_react["default"].createElement(_icon["default"], {
    className: "absoluteCenter",
    path: direction.iconPath,
    size: "24px"
  }))));
};
PagerButton.propTypes = process.env.NODE_ENV !== "production" ? {
  active: _propTypes["default"].bool,
  carouselId: _propTypes["default"].string,
  clickHandler: _propTypes["default"].func,
  directionName: _propTypes["default"].oneOf(['next', 'prev']).isRequired,
  ariaLabelNext: _propTypes["default"].string,
  ariaLabelPrev: _propTypes["default"].string,
  alwaysVisible: _propTypes["default"].bool,
  buttonClassName: _propTypes["default"].string
} : {};
var _default = exports["default"] = PagerButton;